import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/page/index'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/page/login'),
    },
    {
      path: '/details',
      name: 'details',
      component: () => import('@/page/details'),
    },

    {
      path: '/register',
      name: 'register',
      component: () => import('@/page/register'),
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('@/page/order'),
    },
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js